import { useContext } from "react";
import { XtLocale, Hooks, Context } from "@xt/xtbase";

 export const { useTranslation, useDocumentWidth } = Hooks;

const {XtContext} = Context;

export const withT = (Component) => (props) => {
  const { t } = useTranslation();

  return (
    <Component {...props} t={t} />
  );
};

export const withLang = (Component) => (props) => {
  const [appState] = useContext(XtContext);
  const { lang } = appState;

  return (
    <Component {...props} lang={lang} />
  );
};

export const withLogin = (Component) => (props) => {
  const [appState] = useContext(XtContext);
  const { loginStatus } = appState;
  const isLogin = loginStatus == 1;

  return (
    <Component {...props} isLogin={isLogin} />
  );
};

export const withAppState  = (Component) => (props) => {
  const [appState] = useContext(XtContext);

  return (
    <Component {...props} appState={appState} />
  );
};